import * as Sentry from "@sentry/vue";

export default {
    install: (app, options) => {
        const { router } = options;
        Sentry.init({
            environment: process.env.NODE_ENV,
            app,
            dsn: "https://e7b550222c8418be2f6f899962151d1f@o4508618790928384.ingest.de.sentry.io/4508618792566864",
            integrations: [
                Sentry.browserTracingIntegration({ router }),
                Sentry.replayIntegration(),
            ],
            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [/^https:\/\/*.order.xmenu\.it\//],
            allowUrls: [ /^https:\/\/[a-zA-Z0-9\-]+\.order\.xmenu\.it\//],
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }
}
